import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import CreateForm from './CreateForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

function CreateView() {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Crear nuevo caso de éxito"
    >
      <Container maxWidth={false}>
        <Header />
        <CreateForm />
      </Container>
    </Page>
  );
}

export default CreateView;
